var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightsOn50 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(8.485)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(4.061 1.399) rotate(-30)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.137,
    height: 2.273,
    transform: "translate(0.895 4.937) rotate(-60.113)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(0 8.382)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(0.828 12.973) rotate(-30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(3.968 16.558) rotate(-60)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(8.382 15.734)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(11.834 15.206) rotate(-30)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(14.601 12.896) rotate(-60)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(15.734 8.485)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(14.646 5.189) rotate(-30)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(11.92 2.847) rotate(-60)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.991,13.581a4.555,4.555,0,0,0,0-9.109Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightsOn50);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lights-on-50.582461e5060eadd188cae4cdfb6d30a4.svg";